import type { ContentConnectorType, ContentPublishingConnector, ContentPublishingDispatch } from "@/lib/composerCore";

// `ConnectorTypeIcon` was extracted to its own file so this module is
// component-free (helps Fast Refresh). Import it from `./ConnectorTypeIcon`.


// Local alias to avoid collision with imported type symbol shadowing in editor previews
export type ContentPublishingdispatchesAlias = ContentPublishingDispatch[];

export type EditorState = {
  open: boolean;
  connector: ContentPublishingConnector | null;
  connectorType: ContentConnectorType;
  displayName: string;
  // webhook fields
  targetUrl: string;
  authHeaderName: string;
  secretValue: string;
  clearSecret: boolean;
  // email fields
  fromName: string;
  replyTo: string;
  recipients: string[];
  recipientDraft: string;
  subjectTemplate: string;
  // bento fields (publishable + secret keys; from-identity hints)
  bentoSiteUuid: string;
  bentoPublishableKey: string;
  bentoFromName: string;
  bentoFromEmail: string;
  // wordpress fields
  wpSite: string;
  // wordpress_self_hosted fields
  wpShSiteUrl: string;
  wpShUsername: string;
  // ghost fields
  ghostAdminUrl: string;
  // substack (unofficial) fields
  substackPublicationUrl: string;
  // beehiiv fields
  beehiivPublicationId: string;
  // bluesky fields
  bskyHandle: string;
  bskyPdsUrl: string;
  // mastodon fields
  mastoInstanceUrl: string;
};

export const emptyEditor: EditorState = {
  open: false,
  connector: null,
  connectorType: "webhook",
  displayName: "",
  targetUrl: "",
  authHeaderName: "",
  secretValue: "",
  clearSecret: false,
  fromName: "",
  replyTo: "",
  recipients: [],
  recipientDraft: "",
  subjectTemplate: "{{title}}",
  bentoSiteUuid: "",
  bentoPublishableKey: "",
  bentoFromName: "",
  bentoFromEmail: "",
  wpSite: "",
  wpShSiteUrl: "",
  wpShUsername: "",
  ghostAdminUrl: "",
  substackPublicationUrl: "",
  beehiivPublicationId: "",
  bskyHandle: "",
  bskyPdsUrl: "",
  mastoInstanceUrl: "",
};

export const formatDate = (value: string | null) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return value;
  }
};

export const statusVariant = (status: ContentPublishingConnector["status"]) => {
  if (status === "active") return "default" as const;
  if (status === "error") return "destructive" as const;
  return "secondary" as const;
};

export const CONNECTOR_TYPE_LABELS: Record<ContentConnectorType, string> = {
  webhook: "Webhook",
  email: "Email",
  kit: "Kit",
  bento: "Bento",
  wordpress: "WordPress.com",
  wordpress_self_hosted: "WordPress (self-hosted)",
  ghost: "Ghost",
  substack_unofficial: "Substack (unofficial)",
  beehiiv: "Beehiiv",
  buttondown: "Buttondown",
};
